import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'

// collection-controller
enum API {
  // 历史委托
  V1PortalProductsHistoryList = '/swap/v1/portal/products/history-list',
  // 仓位调整记录
  V1PortalLogPositionAdjust = '/swap/v1/portal/log/position-adjust',
  // 按条件查询合约列表
  V1PortalPublicList = '/swap/v1/portal/public/list',
  // 批量撤单
  V1PortalProductsOrders = '/swap/v1/portal/products/orders',
  // 根据条件-批量撤单
  V1PortalProductsBatchOrder = '/swap/v1/portal/products/batch-order',
  // 获取合约自选列表
  V1PortalCollection = '/swap/v1/portal/collection',
  // 条件委托
  V1PortalProductsConditionOrderList = '/swap/v1/portal/products/condition/order/list',
  // 列出所有仓位
  V1PortalPositionListAll = '/swap/v1/portal/position/list-all',
  // 条件委托
  V1PortalProductsConditionList = '/swap/v1/portal/products/condition/list',
  // 按条件查询合约列表
  V1PortalPublic = '/swap/v1/portal/public',
  // 设置合约自选
  V1PerpetualCollection = '/swap/v1/perpetual/collection',
  // 获取合约自选
  V1DeliverCollection = '/swap/v1/deliver/collection',
}

export type TGetV1PortalProductsHistoryListParams = any
export type TGetV1PortalProductsHistoryListResponse = TResponse<{
  rows?: {
    amount?: string // 委托数量
    avgPrice?: string // 平均成交价格
    base?: string // 基础货币名,如btc
    contractCode?: string // 合约Code
    contractDirection?: number // 方向 0:正向,1:反向
    contractType?: string // 合约类型，永续-perpetual、 交割-deliver 、当周交割-week、次周交割-nextWeek、当季交割-quarter、次季交割-nextQuarter
    createdDate?: string // 创建时间
    dealAmount?: string // 已成交数量
    detailSide?: string // 仓位方向 1.开多open_long 2.开空open_short 3.平多close_long 4.平空close_short
    direction?: string // 触发方向，greater大于，less小于
    fee?: string // 该笔订单成交后交的手续费: 正表示得手续费,负表示付手续费
    id?: number // ID
    indexBase?: string // 指数货币
    lever?: string // 杠杆
    liquidationDate?: string // 清算时间
    marginDigit?: number // 保证金小数位
    marketPriceDigit?: number // 标记价格小数位
    modifyDate?: number // 最后操作时间
    orderPriceType?: number // 20 最优20档/10 最优10档/5 最优5档/1 对手价
    orderSize?: string // 委托价值
    positionType?: number // 持仓类型
    price?: string // 委托价格
    profit?: string // 该笔订单成交后对应的盈亏: 正表示盈利,负表示亏损
    quote?: string // 计价货币名，usd,cny,usdt
    reason?: number // 该笔订单取消的理由，0是默认值，1 系统撤销，2 用户取消 其他-委托失败
    refConditionOrderId?: number // 关联的条件订单id
    refOrderCondition?: any
    side?: string // 仓位方向，long多，short空
    source?: string // 来源
    status?: number // 0 等待成交 1 部分成交 2 已经成交 -1 已经撤销
    stopLimitType?: string // 条件单类型  0 -止盈 1-止损 2-计划委托 3：跟踪委托
    stopLoss?: any
    stopProfit?: any
    systemType?: number // 10:限价 11:市价 13:强平单 14:爆仓单 15：穿仓 16：强减
    triggerBy?: string // 计划委托类型: index-指数价格market/mark-标记价格mark/last-最新价格last
    triggerDate?: number // 触发时间
    triggerPrice?: string // 触发价格
    unitAmount?: string // 一张合约对应的quote面值,默认1
    tracingCallback?: string // 跟踪委托回调幅度
    tracingDirection?: string // 跟踪委托触发方向，greater大于，less小于
    tracingPrice?: string // 跟踪委托激活价格
    tracingOrderPriceType?: number // 跟踪委托价格触发方式  1：市价  2：限价
  }[]
  total?: number
}>
export const getV1PortalProductsHistoryList = (params?: TGetV1PortalProductsHistoryListParams) => {
  return hcAxios.get<TGetV1PortalProductsHistoryListResponse>(API.V1PortalProductsHistoryList, { params })
}

export type TGetV1PortalLogPositionAdjustParams = any
export type TGetV1PortalLogPositionAdjustResponse = TResponse<{
  rows?: any[]
  total?: number
}>
export const getV1PortalLogPositionAdjust = (params?: TGetV1PortalLogPositionAdjustParams) => {
  return hcAxios.get<TGetV1PortalLogPositionAdjustResponse>(API.V1PortalLogPositionAdjust, { params })
}

export type TPostV1PortalPublicListParams = {
  query?: {
    contractType?: string
    env?: string
    offset?: string
  }
  body?: {
    base?: string // 基础币
    contractCode?: string // 合约Code
    contractCodes?: string[] // 合约Code 列表
  }
}

export type TPostV1PortalPublicListItem = {
  amount24?: string // 24小时成交张数
  base?: string // 基础货币名
  code?: string // 合约code
  contractType?: string // 合约类型，永续-perpetual、 交割-deliver 、当周交割-week、次周交割-nextWeek、当季交割-quarter、次季交割-nextQuarter
  countDownTimeInterval?: string // 倒计时时间间隔
  direction?: number // 方向 0:正向,1:反向
  env?: number // 是否测试盘 0:线上盘,1:测试盘
  fluctuation?: string // 涨跌幅
  fund?: string // 资金费率
  high?: string // 最高价
  indexBase?: string // 指数货币
  indexPrice?: string // 指数价格
  lastCny?: string // 最新价折合人民币
  liquidationDate?: string // 清算时间
  low?: string // 最低价
  makerRate?: string // maker 汇率
  marginDigit?: number // 保证金精度
  markPrice?: string // 标记价格
  marketPriceDigit?: number // 标记价格最小单位（精度）
  maxLever?: number // 最大杠杆
  minQuoteDigit?: number // 计价货币最小交易小数位
  minTradeDigit?: number // 基础货币最小交易小数位
  minTradeUnit?: number // 最小交易单位
  nextLiquidationInterval?: number // 下一次清算时间差
  openTradeTime?: string // 开盘时间
  price?: string // 最新价
  quote?: string // 计价货币名
  size24?: string // 24小时成交价值
  sort?: number // 排序
  takerRate?: string // taker 汇率
  totalPosition?: string // 持仓量
  tradeStatus?: number // 发布状态:1预发,2上线后7天内,3.上线七天后
  unitAmount?: number // 一张合约对应的quote面值,默认1
}

export type TPostV1PortalPublicListResponse = TResponse<TPostV1PortalPublicListItem[]>

export const postV1PortalPublicList = (params?: TPostV1PortalPublicListParams) => {
  return hcAxios.post<TPostV1PortalPublicListResponse>(API.V1PortalPublicList, params?.body ?? {}, {
    params: params?.query ?? {},
  })
}

export type TDeleteV1PortalProductsOrdersParams = {
  contractType?: any // 合约类型：永续合约 perpetual,交割合约 deliver
  direction?: any // 合约方向 0:正向,1:反向
  env?: any // 0：正式，1：模拟
}
export type TDeleteV1PortalProductsOrdersResponse = TResponse<{}>
export const deleteV1PortalProductsOrders = (params?: TDeleteV1PortalProductsOrdersParams) => {
  return hcAxios.delete<TDeleteV1PortalProductsOrdersResponse>(API.V1PortalProductsOrders, { params })
}

export type TDeleteV1PortalProductsBatchOrderParams = {
  contractType?: any // 合约类型：永续合约 perpetual,交割合约 deliver
  contractCode?: any // 合约code
  indexBase?: any // 指数基础货币
  quote?: any // 计价币
  detailSide?: any // 订单方向
  systemType?: any // 类型 10 限价 11 市价
  stopLimitType?: any // 计划类型 0 止盈  1 止损  2 计划 3跟踪委托
  status?: any // 状态 部分成交  0 未成交
}
export type TDeleteV1PortalProductsBatchOrderResponse = TResponse<{}>
export const deleteV1PortalProductsBatchOrder = (params?: TDeleteV1PortalProductsBatchOrderParams) => {
  return hcAxios.delete<TDeleteV1PortalProductsBatchOrderResponse>(API.V1PortalProductsBatchOrder, { params })
}

export type TGetV1PortalCollectionParams = any
export type TGetV1PortalCollectionResponse = TResponse<
  {
    contractCode?: string // 合约code
    status?: number // 状态：0 正常设置自选  1 取消自选
    userId?: number // 用户Id
  }[]
>
export const getV1PortalCollection = (params?: TGetV1PortalCollectionParams) => {
  return hcAxios.get<TGetV1PortalCollectionResponse>(API.V1PortalCollection, { params })
}

export type TPostV1PortalCollectionParams = {
  contractCode?: string // 合约code
  status?: number // 状态：0 正常设置自选  1 取消自选
  userId?: number // 用户Id
}
export type TPostV1PortalCollectionResponse = TResponse<{
  contractCode?: string
  status?: number
  userId?: number
}>
export const postV1PortalCollection = (data?: TPostV1PortalCollectionParams[]) => {
  return hcAxios.post<TPostV1PortalCollectionResponse>(API.V1PortalCollection, data)
}

export type TGetV1PortalProductsConditionOrderListParams = any
export type TGetV1PortalProductsConditionOrderListResponse = TResponse<{
  rows?: any[]
  total?: number
}>
export const getV1PortalProductsConditionOrderList = (params?: TGetV1PortalProductsConditionOrderListParams) => {
  return hcAxios.get<TGetV1PortalProductsConditionOrderListResponse>(API.V1PortalProductsConditionOrderList, { params })
}

export type TGetV1PortalPositionListAllParams = {
  contractType?: any // 合约类型：永续合约 perpetual,交割合约 deliver
  env?: any // 是否实盘   0：实盘，1：模拟盘
  userId?: any // 跟单模块  userId
  bizType?: any // 合约类型
  selectedMode?: any
}

// 持仓的加仓,平仓委托订单
export type TPositionOrder = {
  amount?: string
  avgPrice?: string
  base?: string
  contractCode?: string
  contractDirection?: number // 0: 正向, 1: 反向
  contractType?: 'perpetual' | 'deliver' | 'week' | 'nextweek' | 'quarter' | 'nextquarter'
  createdDate?: string // date-time format
  dealAmount?: string
  detailSide?: 'close_long' | 'close_short' | 'open_long' | 'open_short' | string
  direction?: 'greater' | 'less'
  fee?: string
  id?: number // int64
  indexBase?: string
  lever?: string
  liquidationDate?: string // date-time format
  marginDigit?: number // int32
  marketPriceDigit?: number // int32
  modifyDate?: number // int64
  orderPriceType?: 20 | 10 | 5 | 1
  orderSize?: string
  positionType?: number // int32
  price?: string
  profit?: string
  quote?: string
  reason?: number // 0: 默认值, 1: 系统撤销, 2: 用户取消, 其他: 委托失败
  side?: 'long' | 'short'
  source?: string
  status?: 0 | 1 | 2 | -1 // 0: 等待成交, 1: 部分成交, 2: 已经成交, -1: 已经撤销
  stopLimitType?: '0' | '1' | '2' // 0: 止盈, 1: 止损, 2: 计划委托
  systemType?: 10 | 11 | 13 | 14 | 15 | 16 // 系统类型细节
  triggerBy?: 'index' | 'market/mark' | 'market/last' | 'last'
  triggerDate?: number // int64
  triggerPrice?: string
  unitAmount?: string
  brokerId?: string | number
  userId?: string | number
  orderFee?: string | number
  openMargin?: string | number
  shadowOpenMargin?: string | number
  shadowAmount?: string | number
}

// 持仓的止盈止损委托订单
type TStopOrder = {
  allType: number
  amount: string
  avgPrice: string
  base: string
  baseDisplayName: string
  beforeClosePositionPrice: string
  bizType: string
  brokerId: number
  contractCode: string
  contractCodeDisplayName: string
  contractDirection: number
  contractType: string
  createdDate: number
  dealAmount: string
  dealMarket: number
  deductedFee: string
  detailSide: 'close_long' | 'close_short' | 'open_long' | 'open_short' | string
  direction: 'less' | 'greater'
  donationFee: string
  donationOpenMargin: string
  donationProfit: string
  dualPosition: number
  env: number
  fastTradeTime: number
  fee: string
  growthType: number
  guaranteedStopLossRate: string
  guaranteedStopLossStatus: number
  id: number
  indexBase: string
  indexBaseDisplayName: string
  ioc: number
  isNftPhoto: number
  lever: string
  liquidatePrice: string
  liquidationDate: number
  marginDigit: number
  marketPriceDigit: number
  maxOrderAmount: number
  merge: number
  mergeId: number
  minOrderAmount: number
  mode: number
  modifyDate: number
  mustMaker: number
  openMargin: string
  orderDonationFee: string
  orderFee: string
  orderPriceType: number
  orderSize: string
  orderType: number
  positionId: number
  positionType: number
  price: string
  principalFee: string
  principalOpenMargin: string
  profit: string
  quote: string
  quoteDisplayName: string
  reason: number
  reduceOnly: number
  refConditionOrderId: number
  refUserId: number
  selectedMode: number
  side: 'long' | 'short'
  sortDate: number
  source: string
  status: number
  stopLimitType: '0' | '1' | string
  systemType: number
  tag: string
  tracingCallback: string
  tracingDirection: string
  tracingOrderPriceType: number
  tracingPrice: string
  traderNickname: string
  traderPhoto: string
  triggerBy: 'last' | 'mark' | 'index' | string
  triggerDate: number
  triggerPrice: string
  unitAmount: string
  userId: number
}

export type TPositionStopProfitAndLossOrder = {
  stopLoss?: TStopOrder
  stopProfit?: TStopOrder
}

export type TPositionRecord = {
  addPositionOrders: TPositionOrder[] // 加仓订单
  amount: string
  autoAddMargin: number
  availableBalance: string // 可用余额(保证金)
  availableDonation: string // 可用赠金(保证金)
  base: string
  baseDisplayName: string
  bizType: string
  brokerId: number // 1：普通单 2：跟单 3：福利中心体验
  closePositionOrders: TPositionOrder[] // 平仓订单
  closingAmount: string
  closingConditionAmount: string
  closingLossConditionAmount: string
  closingProfitConditionAmount: string
  contractCode: string
  contractCodeDisplayName: string
  contractType: string
  createdDate: number
  dealMarket: number // 0：普通单   1：带单   2：跟单
  donationFee: string
  donationMaintenanceMargin: string // 赠金维持保证金
  donationOpenMargin: string // 赠金开仓保证金
  env: number
  fee: string
  feeRate: string
  followUserId: number
  gear: string
  guaranteedStopLossRate: string
  guaranteedStopLossStatus: 1 | 0 // 0 不开启/1-开启
  id: number
  indexBase: string
  indexBaseDisplayName: string
  isNftPhoto: number
  lastPrice: string
  lever: string
  liqudatePrice: string
  liquidationDate: number
  lossTriggerPrice: string
  maintainRate: string
  maintenanceMargin: string
  marginDigit: number
  markPrice: string
  marketPriceDigit: number
  maxLever: string
  minQuoteDigit: number
  minTradeDigit: number
  mode: number
  modifyDate: number
  openMargin: string
  openMarginRate: string
  orderAmount: string
  preLiqudatePrice: string
  price: string // 成交均价
  profitTriggerPrice: string
  quote: string
  quoteDisplayName: string
  realAvailableBalance: string
  realAvailableDonation: string
  realizedSurplus: string
  refUserId: number
  risk: number
  sId: number
  score: string
  selectedMode: number // 0 合仓 1 分仓
  side: string // 仓位类型，long多，short空
  size: string
  sort: number
  stopProfitAndLossOrders: TPositionStopProfitAndLossOrder[]
  traderNickname: string
  traderPhoto: string
  traderUid: number
  traderUserName: string
  trarderIsNftPhoto: number
  type: number // // 0 全仓 1 逐仓
  unRealizedSurplus: string
  unitAmount: string
  userId: number
  shadowAmount: string // 开仓券数量，开仓券占比：shadowAmount/amount * 100
  shadowOpenMargin: string // 开仓券保证金
}

export type TGetV1PortalPositionListAllResponse = TResponse<TPositionRecord[]>
export const getV1PortalPositionListAll = (params?: TGetV1PortalPositionListAllParams) => {
  return hcAxios.get<TGetV1PortalPositionListAllResponse>(API.V1PortalPositionListAll, { params })
}

export type TGetV1PortalProductsConditionListParams = any
export type TGetV1PortalProductsConditionListResponse = TResponse<{
  data?: any[]
  pageNum?: number
  pageSize?: number
  totalCount?: number
  totalPage?: number
}>
export const getV1PortalProductsConditionList = (params?: TGetV1PortalProductsConditionListParams) => {
  return hcAxios.get<TGetV1PortalProductsConditionListResponse>(API.V1PortalProductsConditionList, { params })
}

export type TGetV1PortalPublicParams = any
export type TGetV1PortalPublicResponse = TResponse<
  {
    labelId?: number // 标签Id
    labelName?: string // 标签名
    sort?: number // 排序系数
    swaps?: {
      amount24?: string // 24小时成交张数
      base?: string // 基础货币名
      baseContractCode?: string // 合约code
      code?: string // 合约code
      contractType?: string // 合约类型，永续-perpetual、 交割-deliver 、当周交割-week、次周交割-nextWeek、当季交割-quarter、次季交割-nextQuarter
      countDownTimeInterval?: string // 倒计时时间间隔
      direction?: number // 方向 0:正向,1:反向
      env?: number // 是否测试盘 0:线上盘,1:测试盘
      fluctuation?: string // 涨跌幅
      fund?: string // 资金费率
      high?: string // 最高价
      indexBase?: string // 指数货币
      indexPrice?: string // 指数价格
      lastCny?: string // 最新价折合人民币
      liquidationDate?: string // 清算时间
      low?: string // 最低价
      makerRate?: string // maker 汇率
      marginDigit?: number // 保证金精度
      markPrice?: string // 标记价格
      marketPriceDigit?: number // 标记价格最小单位（精度）
      maxLever?: number // 最大杠杆
      minQuoteDigit?: number // 计价货币最小交易小数位
      minTradeDigit?: number // 基础货币最小交易小数位
      minTradeUnit?: number // 最小交易单位
      nextLiquidationInterval?: number // 下一次清算时间差
      openTradeTime?: string // 开盘时间
      price?: string // 最新价
      quote?: string // 计价货币名
      size24?: string // 24小时成交价值
      sort?: number // 排序
      takerRate?: string // taker 汇率
      totalPosition?: string // 持仓量
      tradeStatus?: number // 发布状态:1预发,2上线后7天内,3.上线七天后
      unitAmount?: number // 一张合约对应的quote面值,默认1
    }[] // 合约详情
  }[]
>
export const getV1PortalPublic = (params?: TGetV1PortalPublicParams) => {
  return hcAxios.get<TGetV1PortalPublicResponse>(API.V1PortalPublic, { params })
}

export type TPostV1PerpetualCollectionParams = {
  contractCode?: string // 合约code
  status?: number // 状态：0 正常设置自选  1 取消自选
  userId?: number // 用户Id
  contractType?: string // 合约类型： perpetual-永续，deliver-交割
}[]
export type TPostV1PerpetualCollectionResponse = TResponse<boolean>
export const postV1PerpetualCollection = (params?: TPostV1PerpetualCollectionParams) => {
  return hcAxios.post<TPostV1PerpetualCollectionResponse>(API.V1PerpetualCollection, params)
}

export type TGetV1PerpetualCollectionParams = {
  env?: any //  0-实盘/1-模拟盘，默认0
}
export type TGetV1PerpetualCollectionResponse = TResponse<
  {
    contractCode?: string // 合约code
    status?: number // 状态：0 正常设置自选  1 取消自选
    userId?: number // 用户Id
    env?: string //  0-实盘/1-模拟盘
    quoteDisplayName?: string // 计价货币前端显示名
    indexBaseDisplayName?: string // 指数货币前端显示名
    contractType?: string // 合约类型，永续-perpetual、 交割-deliver 、当周交割-week、次周交割-nextweek、当季交割-quarter、次季交割-nextquarter
    settlementDate?: number // 交割日期，只用于交割合约
  }[]
>
export const getV1PerpetualCollection = (params?: TGetV1PerpetualCollectionParams) => {
  return hcAxios.get<TGetV1PerpetualCollectionResponse>(API.V1PerpetualCollection, { params })
}

export type TGetV1DeliverCollectionParams = any
export type TGetV1DeliverCollectionResponse = TResponse<
  {
    contractCode?: string // 合约code
    status?: number // 状态：0 正常设置自选  1 取消自选
    userId?: number // 用户Id
  }[]
>
export const getV1DeliverCollection = (params?: TGetV1DeliverCollectionParams) => {
  return hcAxios.get<TGetV1DeliverCollectionResponse>(API.V1DeliverCollection, { params })
}

export type TPostV1DeliverCollectionParams = {
  contractCode?: string // 合约code
  status?: number // 状态：0 正常设置自选  1 取消自选
  userId?: number // 用户Id
}[]
export type TPostV1DeliverCollectionResponse = TResponse<boolean>
export const postV1DeliverCollection = (params?: TPostV1DeliverCollectionParams) => {
  return hcAxios.post<TPostV1DeliverCollectionResponse>(API.V1DeliverCollection, params)
}
